var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import OpportunityService from "../../../Services/Opportunity.service";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import { useVirtualizedApp } from "../../Hooks/useVirtualizedApp";
import { OpportunityModal } from "../../Pages/Opportunity/OpportunityDetail";
const PipelineTableView = ({ pipeline, opportunitySearch, getCheckbox, refreshWatermark, }) => {
    const virtualizedAppContext = useVirtualizedApp();
    const pageSize = 50;
    const searchArgs = React.useMemo(() => (Object.assign(Object.assign({}, opportunitySearch), { refreshWatermark })), [opportunitySearch, refreshWatermark]);
    const [opportunityInModal, setOpportunityInModal] = React.useState(null);
    const [isOpportunityModalOpen, setIsOpportunityModalOpen] = React.useState(false);
    const { table, refresh } = usePagedSortedTable({
        searchArgs,
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            getCheckedItem: (data, index) => data.data[index],
        },
        getNumPages: (result) => 
        // $FlowFixMe
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PagedResult<any>'.
        TotalPageMappers.EngagePagedResult(result, pageSize),
        initialSort: { sort: "OPPORTUNITY_STAGE_UPDATED_DATE", order: "desc" },
        columnsThatCantSort: [],
        getData: (sort, page, _a) => {
            var { refreshWatermark: _rw } = _a, sArgs = __rest(_a, ["refreshWatermark"]);
            return OpportunityService.searchLite(sArgs, {
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
                offset: page * pageSize,
                max: pageSize,
            });
        },
        columns: [
            {
                title: "Name",
                sortId: "OPPORTUNITY_SUBJECT_LAST_NAME",
            },
            {
                title: "Last Stage Change",
                sortId: "OPPORTUNITY_STAGE_UPDATED_DATE",
            },
            {
                title: "Stage",
                sortId: "OPPORTUNITY_STAGE_NAME",
            },
            {
                title: "Entry Date",
                sortId: "OPPORTUNITY_PIPELINE_ENTRY_DATE",
            },
            {
                title: "Assigned To",
                sortId: "OPPORTUNITY_ASSIGNED_TO",
            },
            {
                title: "Opportunity Source",
                sortId: "OPPORTUNITY_SOURCE_NAME",
            },
        ],
        // @ts-expect-error - TS2322 - Type '({ data }: { data: any; }) => any' is not assignable to type 'Node[][] & ((arg1: unknown) => Node[][])'.
        rows: ({ data }) => 
        // @ts-expect-error - TS7006 - Parameter 'opportunity' implicitly has an 'any' type.
        data.map((opportunity) => {
            var _a, _b, _c, _d, _e, _f;
            return [
                _jsx("button", { className: "btn btn-link p-0", onClick: () => {
                        setOpportunityInModal(opportunity);
                        setIsOpportunityModalOpen(true);
                    }, children: (_a = opportunity.subject) === null || _a === void 0 ? void 0 : _a.fullName }, 0),
                (_b = opportunity.stageUpdatedDate) === null || _b === void 0 ? void 0 : _b.toDateString(),
                (_c = opportunity.stage) === null || _c === void 0 ? void 0 : _c.name,
                (_d = opportunity.pipelineEntryDate) === null || _d === void 0 ? void 0 : _d.toDateString(),
                (_e = opportunity.assignedTo) === null || _e === void 0 ? void 0 : _e.fullName,
                (_f = opportunity.opportunitySource) === null || _f === void 0 ? void 0 : _f.name,
            ];
        }),
        noDataComponent: "No opportunities found",
    });
    return (_jsxs("div", { children: [table, opportunityInModal && (_jsx(OpportunityModal, { size: "fullscreen", opportunityId: opportunityInModal.id, onModalClosed: () => {
                    refresh();
                    setIsOpportunityModalOpen(false);
                }, isOpen: isOpportunityModalOpen }))] }));
};
export default PipelineTableView;
